/**
 * @fileoverview gRPC-Web generated client stub for pb.v1alpha1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.19.1
// source: v1alpha1/script_processing.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as v1alpha1_script_processing_pb from '../v1alpha1/script_processing_pb'; // proto import: "v1alpha1/script_processing.proto"


export class ScriptProcessingClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetSignedUrl = new grpcWeb.MethodDescriptor(
    '/pb.v1alpha1.ScriptProcessing/GetSignedUrl',
    grpcWeb.MethodType.UNARY,
    v1alpha1_script_processing_pb.SignedUrlRequest,
    v1alpha1_script_processing_pb.SignedUrlResponse,
    (request: v1alpha1_script_processing_pb.SignedUrlRequest) => {
      return request.serializeBinary();
    },
    v1alpha1_script_processing_pb.SignedUrlResponse.deserializeBinary
  );

  getSignedUrl(
    request: v1alpha1_script_processing_pb.SignedUrlRequest,
    metadata?: grpcWeb.Metadata | null): Promise<v1alpha1_script_processing_pb.SignedUrlResponse>;

  getSignedUrl(
    request: v1alpha1_script_processing_pb.SignedUrlRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: v1alpha1_script_processing_pb.SignedUrlResponse) => void): grpcWeb.ClientReadableStream<v1alpha1_script_processing_pb.SignedUrlResponse>;

  getSignedUrl(
    request: v1alpha1_script_processing_pb.SignedUrlRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: v1alpha1_script_processing_pb.SignedUrlResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pb.v1alpha1.ScriptProcessing/GetSignedUrl',
        request,
        metadata || {},
        this.methodDescriptorGetSignedUrl,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pb.v1alpha1.ScriptProcessing/GetSignedUrl',
    request,
    metadata || {},
    this.methodDescriptorGetSignedUrl);
  }

  methodDescriptorProcessScript = new grpcWeb.MethodDescriptor(
    '/pb.v1alpha1.ScriptProcessing/ProcessScript',
    grpcWeb.MethodType.UNARY,
    v1alpha1_script_processing_pb.ProcessScriptRequest,
    v1alpha1_script_processing_pb.ProcessScriptResponse,
    (request: v1alpha1_script_processing_pb.ProcessScriptRequest) => {
      return request.serializeBinary();
    },
    v1alpha1_script_processing_pb.ProcessScriptResponse.deserializeBinary
  );

  processScript(
    request: v1alpha1_script_processing_pb.ProcessScriptRequest,
    metadata?: grpcWeb.Metadata | null): Promise<v1alpha1_script_processing_pb.ProcessScriptResponse>;

  processScript(
    request: v1alpha1_script_processing_pb.ProcessScriptRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: v1alpha1_script_processing_pb.ProcessScriptResponse) => void): grpcWeb.ClientReadableStream<v1alpha1_script_processing_pb.ProcessScriptResponse>;

  processScript(
    request: v1alpha1_script_processing_pb.ProcessScriptRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: v1alpha1_script_processing_pb.ProcessScriptResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pb.v1alpha1.ScriptProcessing/ProcessScript',
        request,
        metadata || {},
        this.methodDescriptorProcessScript,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pb.v1alpha1.ScriptProcessing/ProcessScript',
    request,
    metadata || {},
    this.methodDescriptorProcessScript);
  }

  methodDescriptorGetScriptInfo = new grpcWeb.MethodDescriptor(
    '/pb.v1alpha1.ScriptProcessing/GetScriptInfo',
    grpcWeb.MethodType.UNARY,
    v1alpha1_script_processing_pb.GetScriptInfoRequest,
    v1alpha1_script_processing_pb.GetScriptInfoResponse,
    (request: v1alpha1_script_processing_pb.GetScriptInfoRequest) => {
      return request.serializeBinary();
    },
    v1alpha1_script_processing_pb.GetScriptInfoResponse.deserializeBinary
  );

  getScriptInfo(
    request: v1alpha1_script_processing_pb.GetScriptInfoRequest,
    metadata?: grpcWeb.Metadata | null): Promise<v1alpha1_script_processing_pb.GetScriptInfoResponse>;

  getScriptInfo(
    request: v1alpha1_script_processing_pb.GetScriptInfoRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: v1alpha1_script_processing_pb.GetScriptInfoResponse) => void): grpcWeb.ClientReadableStream<v1alpha1_script_processing_pb.GetScriptInfoResponse>;

  getScriptInfo(
    request: v1alpha1_script_processing_pb.GetScriptInfoRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: v1alpha1_script_processing_pb.GetScriptInfoResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pb.v1alpha1.ScriptProcessing/GetScriptInfo',
        request,
        metadata || {},
        this.methodDescriptorGetScriptInfo,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pb.v1alpha1.ScriptProcessing/GetScriptInfo',
    request,
    metadata || {},
    this.methodDescriptorGetScriptInfo);
  }

  methodDescriptorListScripts = new grpcWeb.MethodDescriptor(
    '/pb.v1alpha1.ScriptProcessing/ListScripts',
    grpcWeb.MethodType.UNARY,
    v1alpha1_script_processing_pb.ListScriptsRequest,
    v1alpha1_script_processing_pb.ListScriptsResponse,
    (request: v1alpha1_script_processing_pb.ListScriptsRequest) => {
      return request.serializeBinary();
    },
    v1alpha1_script_processing_pb.ListScriptsResponse.deserializeBinary
  );

  listScripts(
    request: v1alpha1_script_processing_pb.ListScriptsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<v1alpha1_script_processing_pb.ListScriptsResponse>;

  listScripts(
    request: v1alpha1_script_processing_pb.ListScriptsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: v1alpha1_script_processing_pb.ListScriptsResponse) => void): grpcWeb.ClientReadableStream<v1alpha1_script_processing_pb.ListScriptsResponse>;

  listScripts(
    request: v1alpha1_script_processing_pb.ListScriptsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: v1alpha1_script_processing_pb.ListScriptsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pb.v1alpha1.ScriptProcessing/ListScripts',
        request,
        metadata || {},
        this.methodDescriptorListScripts,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pb.v1alpha1.ScriptProcessing/ListScripts',
    request,
    metadata || {},
    this.methodDescriptorListScripts);
  }

  methodDescriptorGetScriptPDF = new grpcWeb.MethodDescriptor(
    '/pb.v1alpha1.ScriptProcessing/GetScriptPDF',
    grpcWeb.MethodType.UNARY,
    v1alpha1_script_processing_pb.GetScriptPDFRequest,
    v1alpha1_script_processing_pb.GetScriptPDFResponse,
    (request: v1alpha1_script_processing_pb.GetScriptPDFRequest) => {
      return request.serializeBinary();
    },
    v1alpha1_script_processing_pb.GetScriptPDFResponse.deserializeBinary
  );

  getScriptPDF(
    request: v1alpha1_script_processing_pb.GetScriptPDFRequest,
    metadata?: grpcWeb.Metadata | null): Promise<v1alpha1_script_processing_pb.GetScriptPDFResponse>;

  getScriptPDF(
    request: v1alpha1_script_processing_pb.GetScriptPDFRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: v1alpha1_script_processing_pb.GetScriptPDFResponse) => void): grpcWeb.ClientReadableStream<v1alpha1_script_processing_pb.GetScriptPDFResponse>;

  getScriptPDF(
    request: v1alpha1_script_processing_pb.GetScriptPDFRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: v1alpha1_script_processing_pb.GetScriptPDFResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pb.v1alpha1.ScriptProcessing/GetScriptPDF',
        request,
        metadata || {},
        this.methodDescriptorGetScriptPDF,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pb.v1alpha1.ScriptProcessing/GetScriptPDF',
    request,
    metadata || {},
    this.methodDescriptorGetScriptPDF);
  }

  methodDescriptorDeleteScript = new grpcWeb.MethodDescriptor(
    '/pb.v1alpha1.ScriptProcessing/DeleteScript',
    grpcWeb.MethodType.UNARY,
    v1alpha1_script_processing_pb.DeleteScriptRequest,
    v1alpha1_script_processing_pb.DeleteScriptResponse,
    (request: v1alpha1_script_processing_pb.DeleteScriptRequest) => {
      return request.serializeBinary();
    },
    v1alpha1_script_processing_pb.DeleteScriptResponse.deserializeBinary
  );

  deleteScript(
    request: v1alpha1_script_processing_pb.DeleteScriptRequest,
    metadata?: grpcWeb.Metadata | null): Promise<v1alpha1_script_processing_pb.DeleteScriptResponse>;

  deleteScript(
    request: v1alpha1_script_processing_pb.DeleteScriptRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: v1alpha1_script_processing_pb.DeleteScriptResponse) => void): grpcWeb.ClientReadableStream<v1alpha1_script_processing_pb.DeleteScriptResponse>;

  deleteScript(
    request: v1alpha1_script_processing_pb.DeleteScriptRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: v1alpha1_script_processing_pb.DeleteScriptResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/pb.v1alpha1.ScriptProcessing/DeleteScript',
        request,
        metadata || {},
        this.methodDescriptorDeleteScript,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/pb.v1alpha1.ScriptProcessing/DeleteScript',
    request,
    metadata || {},
    this.methodDescriptorDeleteScript);
  }

}

